export default __webpack_public_path__ + "img/pencil-edit.f178b14.svg";